import { __decorate } from "tslib";
// @ts-ignore
import { Component, Vue } from "vue-property-decorator";
let DatePickerTextbox = class DatePickerTextbox extends Vue {
};
DatePickerTextbox = __decorate([
    Component({
        props: {
            value: {
                default: '',
            },
            label: {
                default: '',
            },
            isEndDate: {
                default: false,
            },
            disabled: {
                default: false,
            },
            dense: {
                default: false,
            },
            hideDetails: {
                default: false,
            },
            hideIcon: {
                default: false
            },
            min: {
                default: null
            },
            rules: {
                default: null
            }
        },
        watch: {
            date() {
                if (!this.$data.date) {
                    this.$data.formattedDate = null;
                    this.$emit("update", null);
                    return;
                }
                let formattedDate = window.dateHandler.convertToUTCTime(this.$data.date);
                if (this.$props.isEndDate) {
                    //should be part of dateHandler at one point
                    formattedDate = `${formattedDate.split("T")[0]}T23:59:59Z`;
                }
                this.$data.formattedDate = formattedDate;
                this.$emit("update", formattedDate);
            },
        },
        data() {
            return {
                show: false,
                date: null,
                dateValue: null,
                formattedDate: null, //used to render the actual value returned as a sanity check
            };
        },
        created() {
            if (!this.$props.value) {
                return;
            }
            this.$data.date = this.$props.value.split("T")[0];
        },
    })
], DatePickerTextbox);
export default DatePickerTextbox;
